import { createAsyncThunk } from "@reduxjs/toolkit";
import { APICall } from "@/config/NetworkUtility";
import { logApiError } from "@/services/apiErrorLogger";

/* ==========================================
   GET BASE NAVIGATIONS
========================================== */

export const getBaseNavigations = createAsyncThunk(
  "baseNavigation/getBaseNavigations",
  async (payload, { rejectWithValue }) => {
    try {
      const queryParams = new URLSearchParams({
        ...payload,
      }).toString();

      const url = `v1/NavigationSetup/GetBaseNavigationList?${queryParams}`;

      const result = await APICall("get", payload, url);

      if (result?.statuscode === 200 || result?.statuscode === 201) {
        return {
          data: result?.data || [],
          pagination: result?.pagination || {},
        };
      }

      return rejectWithValue(result);
    } catch (error) {
      logApiError(error, {
        source: "base navigations",
        endpoint: "getBaseNavigations",
        payload,
      });

      return rejectWithValue(error);
    }
  },
);

/* ==========================================
   CREATE BASE NAVIGATION
========================================== */

export const createBaseNavigation = createAsyncThunk(
  "baseNavigation/createBaseNavigation",
  async (payload, { rejectWithValue }) => {
    try {
      const result = await APICall(
        "post",
        payload,
        "v1/NavigationSetup/BaseNavigationInsert",
      );

      if (result?.statuscode === 200 || result?.statuscode === 201) {
        return result;
      }

      return rejectWithValue(result);
    } catch (error) {
      logApiError(error, {
        source: "base navigations",
        endpoint: "createBaseNavigation",
        payload,
      });

      return rejectWithValue(error);
    }
  },
);

/* ==========================================
   UPDATE BASE NAVIGATION
========================================== */

export const updateBaseNavigation = createAsyncThunk(
  "baseNavigation/updateBaseNavigation",
  async (payload, { rejectWithValue }) => {
    try {
      const result = await APICall(
        "post",
        payload,
        "v1/NavigationSetup/BaseNavigationUpdate",
      );

      if (result?.statuscode === 200 || result?.statuscode === 201) {
        return result;
      }

      return rejectWithValue(result);
    } catch (error) {
      logApiError(error, {
        source: "base navigations",
        endpoint: "updateBaseNavigation",
        payload,
      });

      return rejectWithValue(error);
    }
  },
);
